const ArrowIcon = ({ fill = '#212634', opacity = '0.34' }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={opacity}
      d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
      fill={fill}
    />
  </svg>
);

export default ArrowIcon;
